import script from "./InitialAuxiliaryBatch.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialAuxiliaryBatch.vue?vue&type=script&setup=true&lang=js"

import "./InitialAuxiliaryBatch.vue?vue&type=style&index=0&id=6566658d&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6566658d"]])

export default __exports__